/** The Day view's timeline layouts (scheduled and actual) pad their content by this (theme spacing). */
export const DAY_VIEW_CONTENT_PADDING = 2.5;
